import React, { Component, useEffect, useState } from "react";
import BrokenLinkCheckWithAMC from '../../Modules/Algorithms/BrokenLinkCheckWithAMC'
import AppLayout from "../AppLayout/AppLayoutV2";
import BreadCrumbExtension, { IBreadCrumbExtension } from '../../Controls/BreadCrumbExtension/BreadCrumbExtension'
import {MSACCT_TITLE} from '../../Utilities/QueryBuilderConstants'


import './ProductLifecycleAnalyzer.css'

const breadcrumbItem: IBreadCrumbExtension[] = [
  { text: 'Home', key: 'Home', href: '/' },
  { text: 'Algorithms Center', key: 'ia'},
  { text: 'Broken Link Checkers', key: 'blc'},
];

export default class BrokenLinkCheckerWithAMCPage extends Component {
  render() {
    document.title = MSACCT_TITLE + " | " + "Algorithms Center";
    return (
      <AppLayout
        renderBreadcrumb={() =>
          <BreadCrumbExtension items={breadcrumbItem} />
        }
        renderContentPane={() => <BrokenLinkCheckWithAMC />} />
    )
  }
}
